(function () {
  function initGallery(root) {
    var items = root.querySelectorAll('[data-wn-gallery-item]');
    var box = root.querySelector('[data-wn-lightbox]') || document.querySelector('[data-wn-lightbox]');
    if (!items.length || !box) return;

    var img = box.querySelector('[data-wn-lightbox-img]');
    var cap = box.querySelector('[data-wn-lightbox-caption]');
    var link = box.querySelector('[data-wn-lightbox-enquire]');
    var scrim = box.querySelector('[data-wn-lightbox-scrim]');
    var closeBtn = box.querySelector('[data-wn-lightbox-close]');
    var lastFocused = null;

    function open(item) {
      img.src = item.getAttribute('data-full-src');
      img.alt = item.getAttribute('data-alt') || '';
      var caption = item.getAttribute('data-caption') || '';
      if (caption) {
        cap.textContent = caption;
        cap.hidden = false;
      } else {
        cap.textContent = '';
        cap.hidden = true;
      }
      link.href = item.getAttribute('data-enquire-url');
      lastFocused = document.activeElement;
      box.setAttribute('data-open', 'true');
      box.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      box.setAttribute('data-open', 'false');
      box.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      img.src = '';
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    items.forEach(function (item) {
      item.addEventListener('click', function (e) {
        e.preventDefault();
        open(item);
      });
    });
    if (scrim) scrim.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && box.getAttribute('data-open') === 'true') close();
    });
  }

  function init() {
    document.querySelectorAll('[data-wn-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
